import { SearchOutlined } from '@ant-design/icons';
import { useMutation } from '@tanstack/react-query';
import { Col, DatePicker, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { DefaultOptionType } from 'antd/es/select';
import axiosGraphQL from 'apis/GraphQL/axiosGraphQL';
import { GET_ALL_PLANT } from 'apis/GraphQL/Queries/plantQuery';
import { EinvoiceHistoryApis } from 'apis/EinvoiceHistoryApis';
import { FormFilter, InputForm, SelectForm } from 'components';
import { IParamQraphQL } from 'interfaces/GraphQL/GraphQL';
import Content from 'layouts/Content';
import React, { useEffect, useState } from 'react';

interface IProps {
  isOpen: boolean;
  defaultFilter: any;
  onCancel: () => void;
  onFinish: (values: any) => void;
  total?: number;
}

const spanCol = 6;

const FilterEinvoiceHistory = (props: IProps) => {
  const { isOpen, defaultFilter, onCancel, onFinish, total = 0 } = props;
  const [form] = useForm();

  const [optionsBranch, setOptionsBranch] = useState<DefaultOptionType[]>([]);
  const [optionsSerial, setOptionsSerial] = useState<DefaultOptionType[]>([]);

  const mutationBranch = useMutation({
    mutationKey: ['getAllBranchEinvoice'],
    mutationFn: (params: IParamQraphQL) =>
      axiosGraphQL.post('/graphql', params),
    onSuccess: (res) => {
      setOptionsBranch(
        res.data?.getPlant
          ? res.data?.getPlant.items
              .filter((item: any) => String(item.id) !== '5000')
              .map((item: any) => ({
                label: `${item.id} - ${item.name}`,
                value: item.id,
              }))
          : [],
      );
    },
  });

  const mutationSerials = useMutation({
    mutationKey: ['getDistinctInvoiceSerials'],
    mutationFn: () => EinvoiceHistoryApis.getDistinctInvoiceSerials(),
    onSuccess: (res) => {
      const list = Array.isArray(res) ? res : res?.data || [];
      if (Array.isArray(list) && list.length > 0) {
        setOptionsSerial(
          list.map((s: string) => ({
            label: s,
            value: s,
          })),
        );
      }
    },
  });

  useEffect(() => {
    mutationBranch.mutate({
      query: GET_ALL_PLANT,
    });
    mutationSerials.mutate();
  }, []);

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue({
        plantId: defaultFilter.plantId,
        fromDateToDate: defaultFilter.fromDateToDate,
      });
    }
  }, [isOpen, defaultFilter, form]);

  const handleFinish = (values: any) => {
    onFinish(values);
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Content isOpen={isOpen} className="!mb-6">
      <FormFilter form={form} onFinish={handleFinish} onCancel={handleCancel}>
        <Row gutter={[16, 16]}>
          <Col span={spanCol}>
            <Form.Item label="Chi Nhánh" name="plantId">
              <SelectForm
                placeholder="Mã Chi Nhánh"
                options={optionsBranch}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  String(option?.label ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>

          <Col span={spanCol}>
            <Form.Item label="Mã Bill" name="billNum">
              <InputForm
                placeholder="Tìm Mã Bill"
                suffix={<SearchOutlined className="text-gray-400 text-base" />}
                allowClear
              />
            </Form.Item>
          </Col>

          <Col span={spanCol}>
            <Form.Item label="Mã KH" name="customerId">
              <InputForm
                placeholder="Tìm Mã Khách Hàng"
                suffix={<SearchOutlined className="text-gray-400 text-base" />}
                allowClear
              />
            </Form.Item>
          </Col>

          <Col span={spanCol}>
            <Form.Item
              name="fromDateToDate"
              label="Ngày Phát Hành"
              className="!mb-0"
            >
              <DatePicker.RangePicker
                format="DD/MM/YYYY"
                className="w-full !h-10"
                placeholder={['Từ ngày', 'Đến ngày']}
              />
            </Form.Item>
          </Col>

          <Col span={spanCol}>
            <Form.Item label="Ký Hiệu" name="invoiceSerial" className="!mb-1">
              <SelectForm
                placeholder="Tìm Mã Ký Hiệu"
                options={optionsSerial}
                allowClear
                showSearch
              />
            </Form.Item>
            <div className="text-sm font-medium text-gray-600 mt-1">
              Có{' '}
              <span className="font-semibold text-[#003B70]">
                {Number(total || 0).toLocaleString('vi-VN')}
              </span>{' '}
              hóa đơn
            </div>
          </Col>
        </Row>
      </FormFilter>
    </Content>
  );
};

export default FilterEinvoiceHistory;
